import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "./Home.css";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Board from "./Board";
import Search from "./Popup/Search";
import AppointmentSearchPage from "../../Components/Appointment/AppointmentSearchPage";
import { useApp } from "./../../AppProvider";
import api from "./../../axiosInstance";
import logger from "../../utils/logger";

export default function Home() {
  const datePickerRef = useRef();
  const [openModal, setOpenModal] = useState(false);
  
  const { setBoardDate, boardDate, cardDropDownCondition, setCardDropDownCondition, isModalOpenSearchAppointment, setIsModalOpenSearchAppointment, selectedClinic } = useApp();
  const [apptTypeOptions, setApptTypeOptions] = useState([{ value: "", label: "All Types" }]);

  useEffect(() => {
    if (!selectedClinic?._id) return;
    api.get("/appointmentTypes", { params: { clinicId: selectedClinic._id, isActive: true, limit: 100, page: 1 } })
      .then(res => {
        const types = res.data.data || [];
        setApptTypeOptions([
          { value: "", label: "All Types" },
          ...types.map(t => ({ value: t.name, label: t.name })),
        ]);
      })
      .catch(err => logger.error("Failed to load appointment types:", err));
  }, [selectedClinic?._id]);
  const [selectStartDate, setSelectStartDate] = useState(new Date(boardDate));
  // console.log("BOARD DATE",boardDate)
  const handleSelectDateChange = (date) => {
    const dateString = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    setSelectStartDate(date);
    setBoardDate(dateString);
  };

  const handleSelectDateClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const handleClearDate = () => {
    setSelectStartDate(null);
    setBoardDate(null);
  };

  const isCurrentDate = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  };

  return (
    <div className="home_container">
      <div className="feed">
        <div className="top-section">
          <div className="search" onClick={() => setOpenModal(true)}>
            <SearchOutlinedIcon sx={{ fontSize: { md: '28px', lg: '28px', xl: '28px' } }} />
            <div className="searchtext">Search Patients</div>
          </div>
          {openModal && (
            <Search open={openModal} onClose={setOpenModal} />
          )}
          <div className="top-divider" />
          <div className="select-date" onClick={handleSelectDateClick}>
            <label>
              {selectStartDate
                ? (isCurrentDate(selectStartDate)
                    ? `Today, ${selectStartDate.toLocaleDateString("en-IN", { day: "numeric", month: "short" })}`
                    : selectStartDate.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }))
                : `Today, ${new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short" })}`}
            </label>
            <div className="date-picker-container_home">
              <DatePicker
                className="date-picker_home"
                calendarClassName="ov-datepicker-calendar"
                ref={datePickerRef}
                selected={selectStartDate}
                onChange={handleSelectDateChange}
                customInput={
                  <CalendarMonthOutlinedIcon />
                }
                renderDayContents={(day, date) => {
                  const today = new Date();
                  const isSameMonthYear = date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
                  const className = isSameMonthYear && isCurrentDate(date) ? 'react-datepicker__day--highlighted' : '';
                  return <div className={className}>{day}</div>;
                }}
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled
                }) => (
                  <div>
                    <div className="custom-header">
                      <div className="date-month-year-align">
                        <button className="arrow-calendar" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                          {"<"}
                        </button>
                        <select className="year-dropdown"
                          value={date.getFullYear()}
                          onChange={({ target: { value } }) => changeYear(value)}
                        >
                          {Array.from(new Array(10), (_, i) => i + (new Date().getFullYear() - 5)).map(option => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <select className="month-dropdown"
                          value={date.getMonth()}
                          onChange={({ target: { value } }) => changeMonth(value)}
                        >
                          {[
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                          ].map((month, index) => (
                            <option key={month} value={index}>
                              {month}
                            </option>
                          ))}
                        </select>
                        <button className="arrow-calendar" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                          {">"}
                        </button>
                      </div>
                    </div>
                    <button className="clear-date-button" onClick={handleClearDate}>Reset</button>
                  </div>
                )}
                showPopperArrow={false}
              />
            </div>
          </div>
          <div className="top-divider" />
          <Dropdown
            className="home-Select_condition"
            controlClassName="home__my-dropdown-control"
            options={apptTypeOptions}
            onChange={(option) => setCardDropDownCondition(option.value)}
            value={cardDropDownCondition}
          />
          <div className="top-divider" />
          <button className="home__Book-appointments" style={{ marginLeft: "auto" }} onClick={() => { setIsModalOpenSearchAppointment(true) }}>
            <AddOutlinedIcon sx={{ fontSize: { md: '25px', lg: '25px', xl: '25px' } }} />
            Book Appointments
          </button>
          {isModalOpenSearchAppointment && (
            <AppointmentSearchPage setIsModalOpenSearchAppointment={setIsModalOpenSearchAppointment} />
          )}
        </div>
      </div>
      <div className="bottom-section">
        <h1 className="today_heading">Today</h1>
        <Board />
      </div>
    </div>
  );
}
